export default __webpack_public_path__ + "static/media/ic_dominican_republic.8b8dd622.svg";